export default __webpack_public_path__ + "static/media/Proreview-8.1353fb89.jpg";